import { render, staticRenderFns } from "./DocumentNode.vue?vue&type=template&id=26dbb2b8&"
import script from "./DocumentNode.vue?vue&type=script&lang=js&"
export * from "./DocumentNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports